import _toConsumableArray from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/ui/text_box/ui.text_editor.mask.strategy.default.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import BaseMaskStrategy from "./ui.text_editor.mask.strategy.base";
import { getChar } from "../../events/utils/index";
import Promise from "../../core/polyfills/promise";
var BACKSPACE_INPUT_TYPE = "deleteContentBackward";
var EMPTY_CHAR = " ";

var DefaultMaskStrategy = /*#__PURE__*/function (_BaseMaskStrategy) {
  _inherits(DefaultMaskStrategy, _BaseMaskStrategy);

  function DefaultMaskStrategy() {
    _classCallCheck(this, DefaultMaskStrategy);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultMaskStrategy).apply(this, arguments));
  }

  _createClass(DefaultMaskStrategy, [{
    key: "_getStrategyName",
    value: function _getStrategyName() {
      return "default";
    }
  }, {
    key: "getHandleEventNames",
    value: function getHandleEventNames() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(DefaultMaskStrategy.prototype), "getHandleEventNames", this).call(this)), ["keyPress"]);
    }
  }, {
    key: "_keyPressHandler",
    value: function _keyPressHandler(event) {
      if (this._keyPressHandled) {
        return;
      }

      this._keyPressHandled = true;

      if (this.editor._isControlKeyFired(event)) {
        return;
      }

      var editor = this.editor;

      editor._maskKeyHandler(event, function () {
        return editor._handleKey(getChar(event));
      });
    }
  }, {
    key: "_inputHandler",
    value: function _inputHandler(event) {
      if (this._backspaceInputHandled(event.originalEvent && event.originalEvent.inputType)) {
        this._handleBackspaceInput(event);
      }

      if (event.originalEvent) {
        this._autoFillHandler(event);
      }

      if (this._keyPressHandled) {
        return;
      }

      this._keyPressHandled = true;
      var inputValue = this.editorInput().val();
      var caret = this.editorCaret();

      if (!caret.end) {
        return;
      }

      caret.start = caret.end - 1;
      var oldValue = inputValue.substring(0, caret.start) + inputValue.substring(caret.end);
      var char = inputValue[caret.start];
      var editor = this.editor;
      this.editorInput().val(oldValue);

      editor._caret({
        start: caret.start,
        end: caret.start
      });

      editor._maskKeyHandler(event, function () {
        return editor._handleKey(char);
      });
    }
  }, {
    key: "_backspaceHandler",
    value: function _backspaceHandler(event) {
      var _this = this;

      var editor = this.editor;
      this._keyPressHandled = true;

      var afterBackspaceHandler = function afterBackspaceHandler(needAdjustCaret, callBack) {
        if (needAdjustCaret) {
          editor._direction(_this.DIRECTION.FORWARD);

          editor._adjustCaret();
        }

        var currentCaret = _this.editorCaret();

        return new Promise(function (resolve) {
          clearTimeout(_this._backspaceHandlerTimeout);
          _this._backspaceHandlerTimeout = setTimeout(function () {
            callBack(currentCaret);
            resolve();
          });
        });
      };

      editor._maskKeyHandler(event, function () {
        if (editor._hasSelection()) {
          return afterBackspaceHandler(true, function (currentCaret) {
            editor._displayMask(currentCaret);

            editor._maskRulesChain.reset();
          });
        }

        if (editor._tryMoveCaretBackward()) {
          return afterBackspaceHandler(false, function (currentCaret) {
            _this.editorCaret(currentCaret);
          });
        }

        editor._handleKey(EMPTY_CHAR, _this.DIRECTION.BACKWARD);

        return afterBackspaceHandler(true, function (currentCaret) {
          editor._displayMask(currentCaret);

          editor._maskRulesChain.reset();
        });
      });
    }
  }, {
    key: "_backspaceInputHandled",
    value: function _backspaceInputHandled(inputType) {
      return inputType === BACKSPACE_INPUT_TYPE && !this._keyPressHandled;
    }
  }, {
    key: "_handleBackspaceInput",
    value: function _handleBackspaceInput(event) {
      var _this$editorCaret = this.editorCaret(),
          start = _this$editorCaret.start,
          end = _this$editorCaret.end;

      this.editorCaret({
        start: start + 1,
        end: end + 1
      });

      this._backspaceHandler(event);
    }
  }]);

  return DefaultMaskStrategy;
}(BaseMaskStrategy);

export default DefaultMaskStrategy;